export const MENU_COLLAPSED = 'MENU_COLLAPSED'
export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATUS'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_EVENT_TYPES = 'SET_EVENT_TYPES'
export const SET_VILLAGE_LIST = 'SET_VILLAGE_LIST'
export const SET_LOGIN_USER = 'SET_LOGIN_USER'
